import rules from "@/utils/rules";

export default [
  {
    name: 'Полное наименование',
    type: 'input',
    typeInput: 'text',
    disabled: false,
    rules: [rules.required, rules.counter, rules.rus],
    dataField: 'nameFull',
  },
  {
    name: 'Наименование',
    type: 'input',
    disabled: false,
    cols: 6,
    rules: [rules.required, rules.counter3, rules.rus],
    dataField: 'name',
    // template: () => {
    //   return `123123`
    // }
  },
  {
    name: 'Сокращенное наименование',
    type: 'input',
    typeInput: 'text',
    isPadding: false,
    cols: 6,
    rules: [rules.required, rules.counter3, rules.rus],
    disabled: false,
    dataField: 'nameShort',
  },
  {
    name: 'Тип организации',
    type: 'selector',
    cols: 6,
    sprDataName: 'orgTypes',
    disabled: false,
    dataField: 'type',
  },
  {
    name: 'Наименование учредителя',
    type: 'input',
    cols: 6,
    isPadding: false,
    disabled: false,
    dataField: 'founderName',
  },

  {
    name: 'Адрес',
    type: 'input',
    cols: 6,
    disabled: false,
    dataField: 'address',
  },
  {
    name: 'ИНН',
    type: 'input',
    typeInput: 'number',
    cols: 3,
    disabled: false,
    rules: [rules.required, (v) => v && v.length === 10 || 'не правильный ИНН'],
    dataField: 'inn',
  },
  {
    name: 'КПП',
    type: 'input',
    typeInput: 'number',
    cols: 3,
    disabled: false,
    rules: [rules.required, (v) => v && v.length === 9 || 'не правильный КПП'],
    dataField: 'kpp',
  },
]
